angular.module("app").controller("GamesListPageController", [
    '$scope',
    'pageStatuses',
    'pagination',
    '$timeout',
    'casinoGameService',
    'errorHandler',
    'preloadedData',
    'preloadedCategories',
    'logger',
    'preloadedProviders',
    '$uibModal',
    'settingsService',
    'toolsMap',
    'preloadedFeatures',
    'preloadedThemes',
    'casinoJackpot',
    'userStorage',
    function ($scope, pageStatuses, pagination, $timeout, casinoGameService, errorHandler, preloadedData, preloadedCategories, logger, preloadedProviders, $modal, settingsService, toolsMap, preloadedFeatures, preloadedThemes, casinoJackpot, userStorage) {
        var pendingListRequest;

        $scope.jackpot = angular.copy(casinoJackpot);
        $scope.jackpot.unshift({
            key: "All",
            value: ""
        });
        $scope.tabOptions = {};
        $scope.filterOptions = {
            status: pageStatuses[0],
            jackpot:  $scope.jackpot[0].value,
            gameType: "all",
            search: "",
            searchByExternalId: "",
            justice: "-1",
            manually: "-1",
            missingGameIcon: "-1"
        };

        $scope.multiSelect = {};
        $scope.multiSelect.categories = preloadedCategories;
        $scope.multiSelect.selectedCategories =  [];
        $scope.multiSelect.features = preloadedFeatures;
        $scope.multiSelect.selectedFeatures =  [];
        $scope.multiSelect.themes = preloadedThemes;
        $scope.multiSelect.selectedThemes =  [];
        $scope.multiSelect.providers = preloadedProviders;
        $scope.multiSelect.selectedProviders =  [];

        $scope.getProviderFullName = function (key) {
            for (var i = 0, length = $scope.multiSelect.providers.length; i < length; i++) {
                if ($scope.multiSelect.providers[i].name === key) {
                    return $scope.multiSelect.providers[i].title;
                }
            }
        };

        function reduceData(prev, curr) {
            if (prev === "") {
                return prev + curr.title;
            } else {
                return prev + ", " + curr.title;
            }
        }

        /**
         * Extract needed data from game response
         * @param game
         */
        function extractGame(game) {
            var categories = game.categories.reduce(reduceData, "");
            if (categories === "" ){
                categories = "Not selected";
            }
            var themes = game.themes.reduce(reduceData, "");
            if (themes === "" ){
                themes = "Not selected";
            }
            var features = game.features.reduce(reduceData, "");
            if (features === "" ){
                features = "Not selected";
            }
            var image = null;
            if (!!game["game_icon_1"]) {
                image = game["game_icon_1"];
            } else if (!!game["game_icon_2"]) {
                image = game["game_icon_2"];
            } else if (!!game["game_icon_3"]) {
                image = game["game_icon_3"];
            }
            return {
                name: game.name,
                images: image,
                is_mobile: game.is_mobile == 1? 'Mobile': 'Web',
                categories: categories,
                provider: game.provider_title || $scope.getProviderFullName(game.show_as_provider) || "Not selected",
                features: features,
                themes: themes,
                created_at: game.created_at,
                changed_at: game.changed_at,
                id: game.id,
                status: game.status
            }

        }
        $scope.games = angular.copy(preloadedData.games).map(extractGame);

        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());
        if (angular.isDefined($scope.filterOptions.is_mobile)) {
            $scope.filterOptions.gameType = $scope.filterOptions.is_mobile == 1 ? 'mobile' : 'desktop';
        } else {
            $scope.filterOptions.gameType = 'all'
        }
        $scope.pageStatuses = pageStatuses;

        $scope.pagination = pagination.init(function (resetPage) {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                var requestData = getFiltersValues();
                (resetPage === true) && (requestData.current_page = 1);
                updateList(requestData)
            }, 300);
        }, preloadedData.total_count);


        $scope.addGame = function (game) {
            $modal.open({
                templateUrl: "views/games/add.html",
                controller: "GamesAddPageController",
                resolve: {
                    preloadedGameData: function (casinoGameService, errorHandler) {
                        if (game) {
                            return casinoGameService.get({id: game.id}).then(
                                function (response) {
                                    if (response.status === "ok") {
                                        return angular.copy(response.game)
                                    } else {
                                        errorHandler(response.message);
                                        return {}
                                    }
                                },
                                function (response) {
                                    errorHandler(response.message);
                                    return {}
                                }
                            )
                        } else {
                            return undefined;
                        }

                    },
                    preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                        return casinoCategoryService.get({status: pageStatuses[0], type: "category", is_custom: 0}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.categories)
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedFeatures: function(){
                        return preloadedFeatures;
                    },
                    preloadedThemes: function(){
                        return preloadedThemes;
                    },
                    preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                        return casinoProviderService.get({status: pageStatuses[0]}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.providers)
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    countryCodes: function(resourcesService) {
                        return resourcesService.getResource("countryCodes.json").then(function (data) {
                            return angular.copy(data);
                        },function (response) {
                            return [];
                        });
                    },
                    currencies: function(resourcesService) {
                        return resourcesService.getResource("currencies.json").then(function (data) {
                            return angular.copy(data);
                        },function (response) {
                            return [];
                        });
                    },
                    preloadedLicense: function (licenseService, errorHandler) {
                        return licenseService.get().then(function (response) {
                                if (response && response.status === "ok") {
                                    return response.data;
                                } else {
                                    errorHandler((response) ? response.message : "");
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        );

                    }
                }
            }).result.then(function () {
                var requestData = getFiltersValues();
                updateList(requestData);
            });
        };

        $scope.editGame = function (game) {
            $modal.open({
                templateUrl: "views/games/edit.html",
                controller: "GamesEditPageController",
                resolve: {
                    preloadedGameData: function (casinoGameService, errorHandler) {
                        return casinoGameService.get({id: game.id}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.game)
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                        return casinoCategoryService.get({status: pageStatuses[0], type: "category", is_custom: 0}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.categories)
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                        return casinoProviderService.get({status: pageStatuses[0]}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.providers)
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    countryCodes: function(resourcesService) {
                        return resourcesService.getResource("countryCodes.json").then(function (data) {
                            return angular.copy(data);
                        },function (response) {
                            return [];
                        });
                    },
                    currencies: function(resourcesService) {
                        return resourcesService.getResource("currencies.json").then(function (data) {
                            return angular.copy(data);
                        },function (response) {
                            return [];
                        });
                    },
                    preloadedFeatures: function(){
                        return preloadedFeatures;
                    },
                    preloadedThemes: function(){
                        return preloadedThemes;
                    },
                    preloadedLicense: function (licenseService, errorHandler) {
                        return licenseService.get().then(function (response) {
                                if (response && response.status === "ok") {
                                    return response.data;
                                } else {
                                    errorHandler((response) ? response.message : "");
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        );

                    }
                }
            }).result.then(function () {
                var requestData = getFiltersValues();
                updateList(requestData);
            });
        };

        $scope.switchSkin = function (game) {
            $modal.open({
                templateUrl: "views/games/switchSkinsByQueue.html",
                controller: "GamesSwitchSkinsPageController",
                resolve: {
                    gameName: function(){
                      return game.name;
                    },
                    gameId: function() {
                        return game.id;
                    }
                }
            }).result.then(function (skins) {
                if (skins !== undefined && skins.length){
                    $scope.possibleSkinsModal(skins, game);
                }else {
                    updateList(getFiltersValues());
                }
            });
        };

        $scope.switchSkinOld = function (game) {
            $modal.open({
                templateUrl: "views/games/switchSkins.html",
                controller: "GamesSwitchSkinsPageOldController",
                resolve: {
                    gameName: function(){
                      return game.name;
                    },
                    gameId: function() {
                        return game.id;
                    }
                }
            }).result.then(function () {
                updateList(getFiltersValues());
            });
        };

        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {
            return $scope.pagination.changePage()
        };

        /*
        $scope.publishGame = function (game) {
            casinoGameService.publishGame(game.id).then(
                function (response) {
                    if (response.status == "ok") {
                        spliceFromList(game);
                        logger.logSuccess("global.successfullyPublished");
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };
        */

        $scope.deleteGame = function (game) {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmCommentAction.html",
                controller: "ConfirmWithCommentModalController",
                resolve: {
                    text: function() {
                        return game.status === 'published' ?"templates.modals.confirmDeleteAction":"templates.modals.confirmPublishAction"
                    }
                }
            });
            modalInstance.result.then(
                function (value) {
                    casinoGameService.deleteGame({id: game.id, status: game.status, comment: value}).then(
                        function (response) {
                            if (response.status === "ok") {
                                logger.logSuccess("global.successfullyDeleted");
                                updateList(getFiltersValues())
                            } else {
                                errorHandler(response.message);
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                        }
                    )
                }
            );

        };

        $scope.inactiveToggle = function (item, action, title) {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmCommentAction.html",
                controller: "ConfirmWithCommentModalController",
                resolve: {
                    text: function() {
                        return "templates.modals.confirmToggle" + title + "Action";
                    }
                }
            });
            modalInstance.result.then(function (value) {
                casinoGameService.toggleItemInactive({id: item.id, status: title, comment:value}).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("global.successfullyToggled" + title);
                            updateList(getFiltersValues())

                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                )

            });
        };



        /*
        function spliceFromList(game) {
            var index = $scope.games.indexOf(game);
            if (index != -1) {
                $scope.games.splice(index, 1);
            }
        }
        */

        function updateList(requestOptions) {
            settingsService.setFilters(requestOptions);
            casinoGameService.get(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.games = angular.copy(response.games).map(extractGame);
                        $scope.pagination.totalItems = response.total_count;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        function getFiltersValues() {
            var currentFilters = {};
            currentFilters = {
                current_page: $scope.pagination.page,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status,
                jackpot: $scope.filterOptions.jackpot != $scope.jackpot[0].value ? $scope.filterOptions.jackpot : '',
                categories:  $scope.multiSelect.selectedCategories,
                features: $scope.multiSelect.selectedFeatures,
                themes: $scope.multiSelect.selectedThemes,
                providers: $scope.multiSelect.selectedProviders,
                search: $scope.filterOptions.search,
                external_id: $scope.filterOptions.searchByExternalId,
                is_mobile: ($scope.filterOptions.gameType == 'mobile' ? 1 : ($scope.filterOptions.gameType == 'desktop' ? 0 : undefined)),
                justice: $scope.filterOptions.justice != '-1'? $scope.filterOptions.justice: undefined,
                manually: $scope.filterOptions.manually != '-1'? $scope.filterOptions.manually: undefined,
                missing_game_icon: $scope.filterOptions.missingGameIcon != '-1' ? $scope.filterOptions.missingGameIcon: undefined,
            };


            (currentFilters.is_mobile === undefined) && (delete currentFilters.is_mobile);
            !currentFilters.jackpot && (delete currentFilters.jackpot);
            !currentFilters.search && (delete currentFilters.search);
            !currentFilters.external_id && (delete currentFilters.external_id);
            !currentFilters.justice && (delete  currentFilters.justice);
            !currentFilters.manually && (delete  currentFilters.manually);
            !currentFilters.missing_game_icon && (delete  currentFilters.missing_game_icon);

            return currentFilters
        }

        $scope.listFilterObject = {
            action: function () {
                updateList(getFiltersValues());
            }
        };
        $scope.tools = {};
        if (userStorage.getUserData().permissions.indexOf('manageGameReleaseWithoutQueue') !== -1) {
            $scope.tools.release = {
                action: function (item) {
                    $scope.switchSkinOld(item);
                },
                title: function () {
                    return 'Release Now';
                },
                class: function () {
                    return 'fa-rocket';
                }
            };
        }
        if (userStorage.getUserData().permissions.indexOf('manageAllGames') !== -1) {

            $scope.tools.settings = {
                action: function (item) {
                    $scope.switchSkin(item);
                },
                title: function () {
                    return 'Settings';
                }
            };
            $scope.tools.edit = {
                action: function (item) {
                    $scope.editGame(item);
                },
                title: function () {
                    return 'Edit';
                }
            };
            $scope.tools.copy = {
                action: function (item) {
                    $scope.addGame(item);
                },
                title: function () {
                    return 'Duplicate';
                },
                class: function () {
                    return 'fa-copy';
                }
            };
            $scope.tools.inactiveToggle = {
                action: function (item) {
                    $scope.inactiveToggle(item, toolsMap[$scope.filterOptions.status].inactiveToggle.action, toolsMap[$scope.filterOptions.status].inactiveToggle.title)
                },
                class: function () {
                    return toolsMap[$scope.filterOptions.status].inactiveToggle.class;
                },
                title: function () {
                    return toolsMap[$scope.filterOptions.status].inactiveToggle.title;
                }
            };
            $scope.tools.publishToggle = {
                action: function (games) {
                    $scope.deleteGame(games, toolsMap[$scope.filterOptions.status].publishToggle.action, toolsMap[$scope.filterOptions.status].publishToggle.title)
                },
                class: function () {
                    return $scope.filterOptions.status;
                },
                title: function () {
                    return toolsMap[$scope.filterOptions.status].publishToggle.title;
                }
            }
        }


        $scope.ignoreColumns = {
            id: true,
            status: true
        }

        $scope.possibleSkinsModal = function (skins, game) {
            $modal.open({
                templateUrl: "views/games/managePossibleCancellations.html",
                controller: "ManagePossibleCancellationsPageController",
                resolve: {
                    gameName: function(){
                        return game.name;
                    },
                    gameId: function() {
                        return game.id;
                    },
                    skins: function() {
                        return skins;
                    }
                }
            }).result.then(function () {
                updateList(getFiltersValues());
            });
        };
    }
]);
